import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ViewCell } from '../../ng2-smart-table';

@Component({
  selector: 'app-custom-channel-icon2',
  templateUrl: './custom-channel-icon2.component.html',
  styleUrls: ['./custom-channel-icon2.component.scss']
})
export class CustomChannelIcon2Component implements OnInit {
  @Input() rowData: any;
  @Input() value: any;

  @Output() clicked: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

}
